import React, { createContext, useContext, useState } from "react";

const RotinasContext = createContext();

export const RotinasProvider = ({ children }) => {
  const today = new Date();
  const [rotinas, setRotinas] = useState([]);
  const [loadingRotinas, setLoadingRotinas] = useState(false);

  const buscarRotinasPorPeriodo = async ({
    mes,
    ano,
    idResponsavel,
    idRestaurante,
  }) => {
    setLoadingRotinas(true);
    try {
      const user = sessionStorage.getItem("user");
      const { access_token } = JSON.parse(user);
      const isValid = (v) => v != null && v !== "" && String(v) !== "undefined";
      const params = new URLSearchParams({ mes, ano });
      if (isValid(idRestaurante)) params.append("idRestaurante", idRestaurante);
      if (isValid(idResponsavel)) params.append("idResponsavel", idResponsavel);
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/rotinas?${params}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authentication: access_token,
          },
        }
      );

      if (response.ok) {
        return await response.json();
      } else {
        throw new Error(`Erro ${response.status}: ${response.statusText}`);
      }
    } catch (error) {
      console.error("Erro ao buscar rotinas:", error);
      setRotinas([]);
      throw error;
    } finally {
      setLoadingRotinas(false);
    }
  };

  const salvarRotina = async (novaRotina, restauranteId, idResponsavel) => {
    try {
      const user = sessionStorage.getItem("user");
      const { access_token } = JSON.parse(user);

      const params = new URLSearchParams();
      if (restauranteId != null && restauranteId !== "") params.append("restauranteId", restauranteId);
      if (idResponsavel != null && idResponsavel !== "") params.append("idResponsavel", idResponsavel);
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/rotinas?${params}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authentication: access_token,
          },
          body: JSON.stringify(novaRotina),
        }
      );
      return true;
    } catch (error) {
      return false;
    }
  };

  const atualizarAtividadeRotina = async (
    rotinaId,
    atividadeId,
    atividadeAtualizada
  ) => {
    try {
      const user = sessionStorage.getItem("user");
      const { access_token } = JSON.parse(user);

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/rotinas/${rotinaId}/atividades/${atividadeId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authentication: access_token,
          },
          body: JSON.stringify(atividadeAtualizada),
        }
      );
      return true;
    } catch (error) {
      return false;
    }
  };

  const atualizarResponsavelRotina = async (
    rotinaId,
    novoResponsavelId,
    restauranteId
  ) => {
    try {
      const user = sessionStorage.getItem("user");
      const { access_token } = JSON.parse(user);

      const params = new URLSearchParams({
        idResponsavel: novoResponsavelId,
        restauranteId: restauranteId,
      });

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/rotinas/${rotinaId}/responsavel?${params}`,
        {
          method: "PUT",
          headers: {
            Authentication: `${access_token}`,
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Erro ao atualizar responsável");
      }

      return true;
    } catch (error) {
      console.error("Erro ao atualizar responsável:", error);
      throw error;
    }
  };

  return (
    <RotinasContext.Provider
      value={{
        rotinas,
        setRotinas,
        buscarRotinasPorPeriodo,
        salvarRotina,
        loadingRotinas,
        today,
        atualizarAtividadeRotina,
        atualizarResponsavelRotina,
      }}
    >
      {children}
    </RotinasContext.Provider>
  );
};

export const useRotinas = () => useContext(RotinasContext);
